import { render, staticRenderFns } from "./SaleTransactionModal.vue?vue&type=template&id=5384f686&scoped=true"
import script from "./SaleTransactionModal.vue?vue&type=script&lang=js"
export * from "./SaleTransactionModal.vue?vue&type=script&lang=js"
import style0 from "./SaleTransactionModal.vue?vue&type=style&index=0&id=5384f686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384f686",
  null
  
)

export default component.exports